export default __webpack_public_path__ + "static/media/cv.b59cda04.svg";